import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=6566fa25&scoped=true&lang=pug&"
import script from "./Checkbox.vue?vue&type=script&setup=true&lang=js&"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=6566fa25&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6566fa25",
  null
  
)

export default component.exports